import Vuex, { Store } from 'vuex';
import { RootError } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { jobLists } from './job_lists/';
import { landingPages } from './landing_pages/';
import { publicBot } from './bot/';
import { publicCompany } from '@/store/public/company';
import { AppearanceSettings } from 'packages/job_lists/AppearanceSettings';
import Vue from 'vue';
import { BrandingSettings } from 'packages/company/entities/BrandingSettings';
import { Company } from 'packages/company/entities/Company';
import { LandingPage } from 'packages/landing_pages/LandingPage';
import { DomainEntityType } from 'packages/utilities/domains';
import { publicFormTemplates } from '@/store/public/v1_form_templates';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Vue.use(Vuex);
var state = {
    cities: [],
    appearance: new AppearanceSettings(),
    company: new Company(),
    landingPage: new LandingPage(),
    branding: new BrandingSettings(),
    entityType: DomainEntityType.UNKNOWN,
    error: RootError.NONE,
    privacyPolicy: null,
};
export default new Store({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: {
        privacyPolicy: function (s) { return s.privacyPolicy; },
    },
    modules: {
        jobLists: jobLists,
        landingPages: landingPages,
        publicBot: publicBot,
        publicCompany: publicCompany,
        publicFormTemplates: publicFormTemplates,
    },
});
